<template>
  <div class="categories-list">
    <div
      @click="goToCategoryDetail(0)"
      class="category-name max-w-16"
      :class="{
        'selected': activeCategory == 0,
      }"
    >
      <span>All</span>
    </div>
    <div
      @click="goToCategoryDetail(category.id)"
      v-for="category in categories"
      :key="category.id"
      :class="{
        'selected': activeCategory == category.id,
        'selecting': isSelectingCategory == category.id
      }"
      class="category-name relative"
    >
      <span
        :class="{'opacity-0' : isSelectingCategory == category.id}"
      >
        {{ category.shortName }}
      </span>
      <span
        class="absolute opacity-0 left-0 right-0
        mx-auto aha-spinner aha-spinner--white aha-spinner--xs"
        :class="{'opacity-100' : isSelectingCategory == category.id}"
        style="top: 30%"
      ></span>
    </div>
  </div>
</template>

<script>
import CategoryApi from '@/api/category'
import Utils from '@/util'
import EventBus from '@/eventBus'

export default {
  components: {
  },
  props: {
    categoryId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      categories: [],
      clickingToScroll: null,
      activeCategory: 0,
      isSelectingCategory: -1,
    }
  },
  watch: {
    $route: function handleChangeRoute(newRoute) {
      if (newRoute.name === 'TemplateLibrary'
        && newRoute.query.category) {
        this.activeCategory = newRoute.query.category
      } else {
        this.activeCategory = 0
      }
    },
  },
  mounted() {
    this.checkActiveCategory()
    this.eventBusCategoryLoadingListener()
  },
  created() {
    this.getAllCategories()
  },
  destroyed() {
    EventBus.$off('template-library--category-loaded')
  },
  methods: {
    async getAllCategories() {
      const res = await CategoryApi.getAllCategories()
      this.categories = res.data
    },
    goToCategoryDetail(id) {
      if (id) {
        const query = {
          category: id,
        }
        this.isSelectingCategory = id
        this.$router.push({ path: '/apps/template-library', query })
        Utils.gaTrackEvent('Template Library > Open Category', 'Open Category', '', id)
      } else {
        this.$router.push('/apps/template-library')
      }
    },
    checkActiveCategory() {
      if (this.$route.query.category) this.activeCategory = this.$route.query.category
    },
    eventBusCategoryLoadingListener() {
      EventBus.$on('template-library--category-loaded', () => {
        this.isSelectingCategory = -1
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.category-name {
  display: ruby;
  border-radius: 40px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  @apply text-base-0 cursor-pointer py-2 px-5 inline-block;
  margin: 0.375rem;
  transition: all 0.3s ease;
  text-align: center;
  &.active, &:hover, &:focus {
    border: 1px solid rgba(0, 0, 0, 0);
    background: rgba(255, 255, 255, 0.3);
  }

  &.selected, &:focus {
    background-color: #FFFFFF;
    color: #3F4557;
    border: 1px solid rgba(0, 0, 0, 0);
  }
  &.selecting {
    background: rgba(255, 255, 255, 0.3);
    cursor: none;
  }
}

.categories-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 1023px) {
  .categories-list {
    @apply h-14 flex flex-col;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    padding: 2px;
  }
}
// .aha-spinner--white {
//   border: 2px solid rgba(255, 255, 255, 0.3);
//   border-top-color: #fff;
// }
// .aha-spinner--sm {
//   height: 1.25rem;
//   width: 1.25rem;
// }
// .aha-spinner {
//   -webkit-animation: spin 1s linear infinite;
//   animation: spin 1s linear infinite;
//   display: inline-block;
//   border-radius: 100%;
// }
</style>
